import React, { useEffect } from 'react'

const fixDpi = (canvas, width, height) => {
  canvas.style.width = `${width}px`
  canvas.style.height = `${height}px`
  canvas.width = width * window.devicePixelRatio
  canvas.height = height * window.devicePixelRatio
  canvas.getContext('2d').scale(window.devicePixelRatio, window.devicePixelRatio)
}

const writeText = (canvas, text) => {
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = '#666'
  ctx.font = '10px Arial'
  ctx.fillText(text, 5, 10)
}

const redirect = url => {
  window.open(url, '_blank')
}

const Attribution = () => {
  useEffect(() => {
    const maptilerCanvas = document.querySelector('#map-text-canvas')
    const openstreetmapCanvas = document.querySelector('#map-text-canvas2')

    if (maptilerCanvas && openstreetmapCanvas) {
      fixDpi(maptilerCanvas, 60, 12)
      writeText(maptilerCanvas, '© MapTiler')

      fixDpi(openstreetmapCanvas, 140, 12)
      writeText(openstreetmapCanvas, '© OpenStreetMap contributors')
    }
  }, [])

  return (
    <div className='map-attribution'>
      <canvas
        onClick={() => redirect('https://www.maptiler.com/copyright/')}
        id='map-text-canvas'
        width={60}
        height={12}
      />
      <div> | </div>
      <canvas
        onClick={() => redirect('http://www.openstreetmap.org/copyright')}
        id='map-text-canvas2'
        width={140}
        height={12}
      />
    </div>
  )
}
export default Attribution
